import React from 'react';

import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { TranslateFunction } from 'react-localize-redux';

import { Switch, Typography } from '../../../../components/atoms';

const useStyles = makeStyles((theme: Theme) => ({
  amount: {
    marginRight: theme.spacing(2),
    whiteSpace: 'nowrap',
  },
  roundUpTip: {
    border: `1px solid ${theme.palette.grey[400]}`,
    padding: theme.spacing(2),
  },
  switch: {
    alignItems: 'center',
    display: 'flex',
  },
  topRow: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
}));

export type RoundUpTipProps = {
  amount: string;
  isEnabled?: boolean;
  restaurantName: string;
  toggleRoundUp: (isRoundUpEnabled: boolean) => void;
  translate: TranslateFunction;
};

export function RoundUpTip(props: RoundUpTipProps): JSX.Element {
  const {
    amount,
    isEnabled = false,
    restaurantName,
    toggleRoundUp,
    translate,
  } = props;
  const classes = useStyles();

  const handleOnChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ): void => {
    toggleRoundUp(checked);
  };

  return (
    <div className={classes.roundUpTip}>
      <div className={classes.topRow}>
        <Typography>
          <em>{translate('RoundUpTip_Description')}</em>
        </Typography>

        <div className={classes.switch}>
          <Typography className={classes.amount} variant="body2">
            <em>+{amount}</em>
          </Typography>
          <Switch checked={isEnabled} onChange={handleOnChange} />
        </div>
      </div>
      <Typography variant="caption">
        {translate('Tipping_TipMore', {
          restaurantName,
        })}
      </Typography>
    </div>
  );
}
